var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',{staticStyle:{"background-color":"#D6D6D6"}},[_c('div',[_c('v-container',[_c('ContentCuentos',{attrs:{"cuentos":_vm.cuentos,"title":"EXPLICA CON LALABUM"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }